import { create } from "zustand";

const useDepartmentWiseEmployeeStore = create((set) => ({
  departmentWiseEmployees: [],
  loading: false,
  error: null,

  getDepartmentWiseEmployees: async (departmentId) => {
    set({ loading: true, error: null });
    try {
      const accessToken = localStorage.getItem("accessToken");
      const url = `${process.env.REACT_APP_BASE_URL}/departments/${departmentId}/employees`;
      // console.log("Request URL:", url);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        redirect: "follow",
      });

      const data = await response.json();
      set({ departmentWiseEmployees: data.data || [], loading: false });
      // console.log("Fetched Employees:", data.data);
    } catch (err) {
      console.error(err);
      set({ error: err.message, loading: false });
    }
  },
}));

export default useDepartmentWiseEmployeeStore;
